import { render, staticRenderFns } from "./ChangeParticipantsForm.vue?vue&type=template&id=201c0108&"
import script from "./ChangeParticipantsForm.vue?vue&type=script&lang=js&"
export * from "./ChangeParticipantsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports